import React from "react";
import { Spin } from "antd";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import i18n from "i18next";

const Layout = () => {
  const spinning = useSelector((state) => state.properties.spinning);
  const showZoomWatermark = useSelector((state) => state.properties.showZoomWatermark);

  const antIcon = (
    <div className="loader-indicator-wrapper">
      <span className="icon-tool-row-seats loader-seat-indicator" />
    </div>
  );

  return (
    <Spin spinning={spinning} indicator={antIcon}>
      <main>
        <Helmet>
          <meta charSet="utf-8" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <link rel="manifest" href="../../public/manifest.json" />
          <link rel="shortcut icon" href="../../public/favicon.png" />
          <title>Red Seats</title>
        </Helmet>
        <Outlet />
        {showZoomWatermark && (
          <div className="zoom-watermark">
            {i18n.t("mapeditor.zoom-instruction")}
          </div>
        )}
      </main>
    </Spin>
  );
};

export default Layout;
